export const SET_STATE = 'checkoutPage/flights/SET_STATE';
export const SET_FLIGHTS_DATA = 'checkoutPage/flights/SET_FLIGHTS_DATA';
export const SET_FILTERED_FLIGHTS = 'checkoutPage/flights/SET_FILTERED_FLIGHTS';
export const SORT_FILTERED_FLIGHTS = 'checkoutPage/flights/SORT_FILTERED_FLIGHTS';
export const RESET_FLIGHTS = 'checkoutPage/flights/RESET_FLIGHTS';
export const SET_CHEAPEST_FILTERED_FLIGHT = 'checkoutPage/flights/SET_CHEAPEST_FLIGHT';
export const SET_BEST_FILTERED_FLIGHT = 'checkoutPage/flights/SET_BEST_FLIGHT';
